module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ec.d89360d3.png";